/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_ClinicInputs */

const en_map_clinic = /** @type {(inputs: Map_ClinicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clinic`)
};

const fr_map_clinic = /** @type {(inputs: Map_ClinicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clinique`)
};

const ms_sg2_map_clinic = /** @type {(inputs: Map_ClinicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klinik`)
};

/**
* | output |
* | --- |
* | "Clinic" |
*
* @param {Map_ClinicInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_clinic = /** @type {((inputs?: Map_ClinicInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_ClinicInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_clinic(inputs)
	if (locale === "fr") return fr_map_clinic(inputs)
	return ms_sg2_map_clinic(inputs)
});